import { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import { Chart as DevChart } from "devextreme-react";
import { CommonSeriesSettings } from "devextreme-react/chart";

import ChartItem from "./ChartItem";

export default function ChartContainer() {
  const { chartType } = useSelector((state) => ({
    chartType: state.chartType.type,
  }));
  const dispatch = useDispatch();

  return (
    (chartType == "AREA" ||
      chartType == "SPLINE_AREA" ||
      chartType == "STEP_AREA" ||
      chartType == "STANDARD_BAR" ||
      chartType == "SIDE_BY_SIDE_BAR" ||
      chartType == "STACKED_BAR" ||
      chartType == "FULL_STACKED_BAR" ||
      chartType == "SIDE_BY_SIDE_STACKED_BAR" ||
      chartType == "SIDE_BY_SIDE_FULL_STACKED_BAR" ||
      chartType == "BI_DIRECTIONAL_BAR" ||
      chartType == "LINE" ||
      chartType == "SPLINE" ||
      chartType == "STEP_LINE") && <ChartItem />
  );
}
